import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { getEntityName } from "@/components/UnifiedRegistry/utils";
import { ActionType, ChangelogEntry } from "@/queries";

const DeleteEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.DELETE>>();

  const deletedName = event.action_payload?.name;

  return (
    <EventTitleWrapper>
      <ActionText>Deleted {!deletedName && getEntityName(event.entity_type)}</ActionText>
      {deletedName && <EntityLink type={event.entity_type} name={deletedName} />}
    </EventTitleWrapper>
  );
};

export default DeleteEventTitle;
